import axios from 'axios';

const client = axios.create({
  baseURL: `https://${window.ENV.mtRecommendationsUrl}`,
});

/**
 * Get recommended products from MT
 * week (Date) needs to be in the format of YYYYMMDD
 * 
 * @param {string} week week or date is required for a recommendation
 * @param {string} [customerId] The userId is fetched from the subscriptions API and is optional
 * @param {string} [subscriptionId] The menuId is required for the respective date and is optional
 */
const getRecommendedProducts = async (week, customerId, subscriptionId) => {
  const requestPath = customerId && subscriptionId
    ? `/${week}/${customerId}/${subscriptionId}`
    : `/${week}`;
  const { data } = await client.post(requestPath);

  return {
    recommendedProducts: data.recommendations.map((item) => ({
      variant_id: parseInt(item.variant_id),
      product_id: parseInt(item.product_id),
    })),
    recommendationType: data.recommendations_type,
    week: data.week,
  };;
};


export {
  getRecommendedProducts,
};
